<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M4.35 4.95L19.65 19.05"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <path
    d="M9.5998 16.8V6.39999L19.1998 4.79999V15.2M9.5998 16.8C9.5998 18.1255 8.52529 19.2 7.1998 19.2C5.87432 19.2 4.7998 18.1255 4.7998 16.8C4.7998 15.4745 5.87432 14.4 7.1998 14.4C8.52529 14.4 9.5998 15.4745 9.5998 16.8ZM19.1998 15.2C19.1998 16.5255 18.1253 17.6 16.7998 17.6C15.4743 17.6 14.3998 16.5255 14.3998 15.2C14.3998 13.8745 15.4743 12.8 16.7998 12.8C18.1253 12.8 19.1998 13.8745 19.1998 15.2Z"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
